import { Map } from "immutable";

import { CONFIDENCE_THRESHOLD } from "seneca-common/features/exam-questions/consts";

import QuestionStat from "../../../../../../models/Assignee/QuestionStat";

type State = Map<string, QuestionStat>;

export function getIndividualQuestionStats(state: State, questionId: string) {
  return state.get(questionId);
}

export function hasQuestionStat(state: State, questionId: string) {
  return !!getIndividualQuestionStats(state, questionId);
}

export function getMark(state: QuestionStat) {
  return state.get("mark");
}

export function getMarksTotal(state: QuestionStat) {
  return state.get("marksTotal");
}

export function getStudyTime(state: QuestionStat) {
  return state.get("studyTime");
}

export function getAnswerTimeCreated(state: QuestionStat) {
  return state.get("answerTimeCreated");
}

export function getFlagged(state: QuestionStat) {
  return state.get("flagged");
}

export function getTeacherMark(state: QuestionStat) {
  return state.get("teacherMark");
}

export function getEmbeddedAnswerMarks(state: QuestionStat) {
  return state.get("embeddedAnswerMarks");
}

export function getSelfMark(state: QuestionStat) {
  return state.get("selfMark");
}

export function getConfidence(state: QuestionStat) {
  return state.get("confidence");
}

export function getNeedsMarking(state?: QuestionStat) {
  const answerExists = !!state?.get("answerTimeCreated");
  const lowConfidence =
    (state?.get("confidence") ?? Infinity) < CONFIDENCE_THRESHOLD;
  const noAutomark = state?.get("mark") === undefined;
  const noTeacherMark = state?.get("teacherMark") === undefined;
  const flagged = !!state?.get("flagged");

  return (
    answerExists && noTeacherMark && (lowConfidence || noAutomark || flagged)
  );
}
